import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import Banner from "./Banner"
import PricingSection from "./PricingSection"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "./index.scss"
import "@styles/global.scss"

const Pricing = props => {
  return (
    <div>
      <EngineIDNavBar />
      <Banner />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <PricingSection></PricingSection>
        </div>
      </div>
      <CTASignUpLong />
      <Footer />
    </div>
  )
}

export default Pricing
